/**
 * Represents a consistent past date value, used as an expiration date for cookies.
 *
 * We use them to delete cookies since browsers and Android cookie managers
 * automatically delete expired cookies.
 */

export const DATE_IN_THE_PAST_ANDROID = '1970-01-01T00:00:00.00+00:00'; // ISO 8601
export const DATE_IN_THE_PAST_WEB = 'Thu, 01 Jan 1970 00:00:00 UTC'; // Unix epoch date
